import React, { useEffect } from 'react';

import Table from 'components/new_ui/Table';
import { useContext as useMembersContext } from 'components/Managers/Members/Context';
import { useContext as useTeamsContext } from 'components/Managers/Teams/Context';
import { useContext } from 'components/Managers/Programs/Context';
import { columnsMembers } from './columns';

export default function MembersTable() {
  const { dispatch: dispatchMembers, actions: actionsMembers, state: stateMembers } = useMembersContext();
  const { state: stateTeams } = useTeamsContext();
  const { dispatch, actions } = useContext();

  useEffect(() => {
    actionsMembers.load(dispatchMembers);
  }, []);

  const data = stateMembers.members || [];

  return (
    <div className="pt-2">
      <Table
        title=" "
        columns={columnsMembers(stateTeams.teams)}
        data={data}
        loading={stateMembers.members === null}
        afterSelect={(selectedRows) => actions.selectMembers(dispatch, selectedRows)}
      />
    </div>
  );
}
